import Repository from './repository'

const resource = '/tramitacaoorcamento'

export default {
  get (data) {
    return Repository.get(`${resource}?cdorcamento=${data}`)
  },
}
